/* eslint import/order: 0 */

import DialogModal from './DialogModal/DialogModal'

import ServerErrorModal from './ServerErrorModal/ServerErrorModal'
import SomethingWentWrongModal from './SomethingWentWrongModal/SomethingWentWrongModal'
import ChangesSaveSuccessModal from './ChangesSaveSuccessModal/ChangesSaveSuccessModal'
import CardUpdateSuccessModal from './CardUpdateSuccessModal/CardUpdateSuccessModal'
import ProductDetailsModal from './ProductDetailsModal/ProductDetailsModal'
import NewProductDetailsModal from './NewProductDetailsModal/NewProductDetailsModal'
import SameFragranceErrorModal from './SameFragranceErrorModal/SameFragranceErrorModal'
import RedeemConfirmationModal from './RedeemConfirmationModal/RedeemConfirmationModal'
import RedeemSuccessModal from './RedeemSuccessModal/RedeemSuccessModal'
import LoginRequiredModal from './LoginRequiredModal/LoginRequiredModal'
import QuizStartModal from './QuizStartModal/QuizStartModal'
import ThankYouQueueModal from './ThankYouQueueModal/ThankYouQueueModal'
import PickDateModal from './PickDateModal/PickDateModal'
import MembershipInfoModal from './MembershipInfoModal/MembershipInfoModal'
import FirstTimeVisitModal from './FirstTimeVisitModal/FirstTimeVisitModal'

// Queue
import HowQueueWorksModal from './HowQueueWorksModal/HowQueueWorksModal'

// New products
import MakeupModal from './newProducts/MakeupModal/MakeupModal'
import SkincareModal from './newProducts/SkincareModal/SkincareModal'
import LipBalmsModal from './newProducts/LipBalmsModal/LipBalmsModal'

// Skip a Month
import SkipAMonthModal from './SkipAMonthModal/SkipAMonthModal'
import SkipAMonthSuccessModal from './SkipAMonthSuccessModal/SkipAMonthSuccessModal'

// Cancel skip
import UnskipSuccessModal from './UnskipSuccessModal/UnskipSuccessModal'

// Card error
import ErrorCardModal from './ErrorCardModal/ErrorCardModal'

// Update PayPal
import ErrorPayPalModal from './ErrorPayPalModal/ErrorPayPalModal'
import AlreadyUpdatedToPayPalModal from './AlreadyUpdatedToPayPalModal/AlreadyUpdatedToPayPalModal'

// Upgrade Subscription
import UpgradeSubscriptionModal from './UpgradeSubscriptionModal/UpgradeSubscriptionModal'
import QueueUpgradeModal from './QueueUpgradeModal/QueueUpgradeModal'

// Cancel Subscription
import CancelSubscriptionModal from './cancelSubscription/CancelSubscriptionModal/CancelSubscriptionModal'
import BeforeYouGoModal from './cancelSubscription/BeforeYouGoModal/BeforeYouGoModal'
import OneLastQuestionModal from './cancelSubscription/OneLastQuestionModal/OneLastQuestionModal'
import SubscriptionWasCancelledModal from './cancelSubscription/SubscriptionWasCancelledModal/SubscriptionWasCancelledModal'
import ProlongOfferModal from './cancelSubscription/ProlongOfferModal/ProlongOfferModal'
import ProlongThankYouModal from './cancelSubscription/ProlongThankYouModal/ProlongThankYouModal'
import PauseSubscriptionModal from './cancelSubscription/PauseSubscriptionModal/PauseSubscriptionModal'
import UnpauseRequiredModal from './cancelSubscription/UnpauseRequiredModal/UnpauseRequiredModal'
import UnsubscribeProductsModal from './cancelSubscription/UnsubscribeProductsModal/UnsubscribeProductsModal'
import RefundModal from './cancelSubscription/RefundModal/RefundModal'
import RefundOnTheDayOfCharge from './cancelSubscription/RefundOnTheDayOfCharge/RefundOnTheDayOfCharge'
import OfferTest25offModal from 'components/_new/modals/cancelSubscription/OfferTest25offModal/OfferTest25offModal'
import OfferTest25offSuccessModal from 'components/_new/modals/cancelSubscription/OfferTest25offSuccessModal/OfferTest25offSuccessModal'
import FeedbackModal from './cancelSubscription/FeedbackModal/FeedbackModal'
import FeedbackErrorModal from 'pages/CancelSubscriptionPage/FeedbackForm/FeedbackErrorModal/FeedbackErrorModal'

// Smart Search
import WeMissedYouModal from './WeMissedYouModal/WeMissedYouModal'
import TryTwoThreeFragrancesModal from './TryTwoThreeFragrancesModal/TryTwoThreeFragrancesModal'

// Prepaid Card
import PrepaidCardWithDiscountModal from './prepaidCard/PrepaidCardWithDiscountModal/PrepaidCardWithDiscountModal'
import PrepaidCardWithSubscriptionPlansModal from './prepaidCard/PrepaidCardWithSubscriptionPlansModal/PrepaidCardWithSubscriptionPlansModal'

// Resubscribe
import ResubscribeSuccessModal from './resubscribe/ResubscribeSuccessModal/ResubscribeSuccessModal'
import GetBackTogetherModal from './resubscribe/GetBackTogetherModal/GetBackTogetherModal'
import ResubscribeWithDiscountModal from './resubscribe/ResubscribeWithDiscountModal/ResubscribeWithDiscountModal'
import SuccessfullyResubscribedModal from './resubscribe/SuccessfullyResubscribedModal/SuccessfullyResubscribedModal'
import ReactivateSubscriptionModal from './resubscribe/ReactivateSubscriptionModal/ReactivateSubscriptionModal'

// GiftSets
import GiftSetQuickViewModal from './GiftsetQuickViewModal/GiftSetQuickViewModal'

// Gifts
import SetGiftDateModal from './gifts/SetGiftDateModal/SetGiftDateModal'
import ChooseGiftSizeModal from './gifts/ChooseGiftSizeModal/ChooseGiftSizeModal'
import ChooseGiftCardSkinModal from './gifts/ChooseGiftCardSkinModal/ChooseGiftCardSkinModal'
import ChooseGiftCardValueModal from './gifts/ChooseGiftCardValueModal/ChooseGiftCardValueModal'
import SetGiftRecipientInfoModal from './gifts/SetGiftRecipientInfoModal/SetGiftRecipientInfoModal'
import ChooseGiftCardDeliveryTypeModal from './gifts/ChooseGiftCardDeliveryTypeModal/ChooseGiftCardDeliveryTypeModal'
import GiftRedeemedModal from './gifts/GiftRedeemedModal/GiftRedeemedModal'

// Review
import ReviewItemListModal from './review/ReviewItemListModal/ReviewItemListModal'
import ReviewComposerModal from './review/ReviewComposerModal/ReviewComposerModal'
import ReviewEditModal from './review/ReviewEditModal/ReviewEditModal'
import ReviewTagsModal from './review/ReviewTagsModal/ReviewTagsModal'
import RecommendationsModal from './review/RecommendationsModal/RecommendationsModal'
import IncubatorReviewEditModal from './review/IncubatorReviewEditModal/IncubatorReviewEditModal'

// Pause Subscription

import UnpauseSubscriptionModal from './pauseSubscription/UnpauseSubscriptionModal/UnpauseSubscriptionModal'
import PauseSuccessModal from './pauseSubscription/PauseSuccessModal/PauseSuccessModal'
import PauseOneMonthSuccessModal from './pauseSubscription/PauseOneMonthSuccessModal/PauseOneMonthSuccessModal'

// Invite
import ChooseFriendsToInviteModal from './ChooseFriendsToInviteModal/ChooseFriendsToInviteModal'

// Register
import FacebookRegisterModal from './FacebookRegisterModal/FacebookRegisterModal'
import RemindPasswordModal from './RemindPasswordModal/RemindPasswordModal'

// Password
import ShortPasswordModal from './ShortPasswordModal/ShortPasswordModal'

// Products
import RecommendationTagModal from './RecommendationTagModal/RecommendationTagModal'
import NoteRecommendationsModal from './NoteRecommendationsModal/NoteRecommendationsModal'

// Payment
import AddressValidationModal from './AddressValidationModal/AddressValidationModal'
import ErrorCVVModal from './ErrorCVVModal/ErrorCVVModal'
import LeavePaymentModal from './LeavePaymentModal/LeavePaymentModal'

// Downgrade
import PreparingDowngradeModal from './PreparingDowngradeModal/PreparingDowngradeModal'
import AlreadyDowngradeModal from './AlreadyDowngradeModal/AlreadyDowngradeModal'

// Limited Edition Products
import NeedUpdateAddressModal from './limitedEditionProducts/NeedUpdateAddressModal/NeedUpdateAddressModal'
import NeedUpdateCardModal from './limitedEditionProducts/NeedUpdateCardModal/NeedUpdateCardModal'
import NeedChangeFrequencyModal from './limitedEditionProducts/NeedChangeFrequencyModal/NeedChangeFrequencyModal'
import NeedResubscribeModal from './limitedEditionProducts/NeedResubscribeModal/NeedResubscribeModal'
import NeedSubscribeModal from './limitedEditionProducts/NeedSubscribeModal/NeedSubscribeModal'
import NeedUnpauseModal from './limitedEditionProducts/NeedUnpauseModal/NeedUnpauseModal'
import NeedUnskipModal from './limitedEditionProducts/NeedUnskipModal/NeedUnskipModal'
import OutOfStockModal from './limitedEditionProducts/OutOfStockModal/OutOfStockModal'
import OutOfStockNotifyModal from './limitedEditionProducts/OutOfStockNotifyModal/OutOfStockNotifyModal'
import PutFirstInQueueModal from './limitedEditionProducts/PutFirstInQueueModal/PutFirstInQueueModal'

// Premium Products
import WelcomeBackModal from './premiumProducts/WelcomeBackModal/WelcomeBackModal'
import AddedProductModal from './premiumProducts/AddedProductModal/AddedProductModal'
import NeedCardUpdateModal from './premiumProducts/NeedCardUpdateModal/NeedCardUpdateModal'
import NeedPaymentDataModal from './premiumProducts/NeedPaymentDataModal/NeedPaymentDataModal'
import NeedSubscriptionModal from './premiumProducts/NeedSubscriptionModal/NeedSubscriptionModal'

import SkincareProductDetailsModal from 'components/_new/modals/SkincareProductDetailsModal/SkincareProductDetailsModal'
import FlashSaleModal from 'components/_new/modals/FlashSaleModal/FlashSaleModal'
import TossInModal from 'components/_new/modals/TossInModal/TossInModal'

// Humble ------------------------------------------------------------------ /

import HumbleServerErrorModal from 'components/_new/modals/ServerErrorModal/ServerErrorModal'
import FeedbackSuccessModal from 'components/_new/modals/FeedbackSuccessModal/FeedbackSuccessModal'
import FlashSaleExpiredModal from 'pages/bundle/FlashSaleBundlePage/FlashSaleExpiredModal/FlashSaleExpiredModal'

import VerifyShippingAddressModal from 'components/_new/modals/verifyShippingAddress/VerifyShippingAddressModal/VerifyShippingAddressModal'
import UndeliverableAddressModal from 'components/_new/modals/verifyShippingAddress/UndeliverableAddressModal/UndeliverableAddressModal'


export default {
  DialogModal,
  ServerErrorModal,
  SomethingWentWrongModal,
  ChangesSaveSuccessModal,
  CardUpdateSuccessModal,
  ProductDetailsModal,
  NewProductDetailsModal,
  SameFragranceErrorModal,
  RedeemConfirmationModal,
  RedeemSuccessModal,
  QuizStartModal,
  PickDateModal,
  MembershipInfoModal,
  FirstTimeVisitModal,

  // Queue
  HowQueueWorksModal,

  // New Products
  MakeupModal,
  SkincareModal,
  LipBalmsModal,

  // Skip a Month
  SkipAMonthModal,
  SkipAMonthSuccessModal,
  UnskipSuccessModal,

  // Card error
  ErrorCardModal,

  // Update PayPal
  ErrorPayPalModal,
  AlreadyUpdatedToPayPalModal,

  // Upgrade Subscription
  UpgradeSubscriptionModal,
  QueueUpgradeModal,

  // Cancel Subscription
  CancelSubscriptionModal,
  BeforeYouGoModal,
  OneLastQuestionModal,
  SubscriptionWasCancelledModal,
  ProlongOfferModal,
  ProlongThankYouModal,
  PauseSubscriptionModal,
  UnpauseSubscriptionModal,
  UnsubscribeProductsModal,
  RefundModal,
  RefundOnTheDayOfCharge,
  OfferTest25offModal,
  OfferTest25offSuccessModal,
  FeedbackModal,
  FeedbackErrorModal,

  // Smart Search
  WeMissedYouModal,
  TryTwoThreeFragrancesModal,

  // Prepaid Card
  PrepaidCardWithDiscountModal,
  PrepaidCardWithSubscriptionPlansModal,

  // Resubscribe
  ResubscribeSuccessModal,
  GetBackTogetherModal,
  ResubscribeWithDiscountModal,
  SuccessfullyResubscribedModal,
  ReactivateSubscriptionModal,

  // GiftSet
  GiftSetQuickViewModal,

  // Gifts
  SetGiftDateModal,
  ChooseGiftSizeModal,
  ChooseGiftCardSkinModal,
  ChooseGiftCardValueModal,
  SetGiftRecipientInfoModal,
  ChooseGiftCardDeliveryTypeModal,
  GiftRedeemedModal,

  // Review
  ReviewItemListModal,
  ReviewComposerModal,
  ReviewEditModal,
  ReviewTagsModal,
  IncubatorReviewEditModal,
  LoginRequiredModal,
  RecommendationsModal,

  // Pause Subscription
  UnpauseRequiredModal,
  PauseSuccessModal,
  PauseOneMonthSuccessModal,

  // Invite
  ChooseFriendsToInviteModal,

  // Register
  FacebookRegisterModal,
  RemindPasswordModal,

  // Password
  ShortPasswordModal,

  // ThanYou
  ThankYouQueueModal,

  // Products
  RecommendationTagModal,
  NoteRecommendationsModal,

  // Payment
  AddressValidationModal,
  ErrorCVVModal,
  LeavePaymentModal,

  // Downgrade
  PreparingDowngradeModal,
  AlreadyDowngradeModal,

  // Limited Edition Products
  NeedUpdateAddressModal,
  NeedUpdateCardModal,
  NeedChangeFrequencyModal,
  NeedResubscribeModal,
  NeedSubscribeModal,
  NeedUnpauseModal,
  NeedUnskipModal,
  OutOfStockModal,
  OutOfStockNotifyModal,
  PutFirstInQueueModal,

  // Premium Products
  WelcomeBackModal,
  AddedProductModal,
  NeedCardUpdateModal,
  NeedPaymentDataModal,
  NeedSubscriptionModal,

  SkincareProductDetailsModal,
  FlashSaleModal,
  TossInModal,

  // Humble ------------------------------------------------------------------ /

  HumbleServerErrorModal,
  FlashSaleExpiredModal,
  FeedbackSuccessModal,

  VerifyShippingAddressModal,
  UndeliverableAddressModal,
}
